/* eslint-disable */

import Vue from "vue"
import { mapState } from "vuex"

export default {
  data() {
    return {
      amplitudeUnsubHandler: null,
    }
  },
  mounted() {
    var vm = this

    ;(function (e, t) {
      var n = e.amplitude || { _q: [], _iq: {} }
      var r = t.createElement("script")
      r.type = "text/javascript"
      r.integrity =
        "sha384-d/yhnowERvm+7eCU79T/bYjOiMmq4F11ElWYLmt0ktvYEVgqLDazh4+gW9CKMpYW"
      r.crossOrigin = "anonymous"
      r.async = true
      r.src = "https://cdn.amplitude.com/libs/amplitude-5.2.2-min.gz.js"
      r.onload = function () {
        if (!e.amplitude.runQueuedFunctions) {
          console.log("[Amplitude] Error: could not load SDK")
        }
      }
      var i = t.getElementsByTagName("script")[0]
      i.parentNode.insertBefore(r,i)
      function s(e, t) {
        e.prototype[t] = function () {
          this._q.push([t].concat(Array.prototype.slice.call(arguments, 0)))
          return this
        }
      }
      var o = function () {
        this._q = []
        return this
      }
      var a = [
        "add",
        "append",
        "clearAll",
        "prepend",
        "set",
        "setOnce",
        "unset",
      ]
      for (var u = 0; u < a.length; u++) {
        s(o, a[u])
      }
      n.Identify = o
      var c = function () {
        this._q = []
        return this
      }
      var l = [
        "setProductId",
        "setQuantity",
        "setPrice",
        "setRevenueType",
        "setEventProperties",
      ]
      for (var p = 0; p < l.length; p++) {
        s(c, l[p])
      }
      n.Revenue = c
      var d = [
        "init",
        "logEvent",
        "logRevenue",
        "setUserId",
        "setUserProperties",
        "setOptOut",
        "setVersionName",
        "setDomain",
        "setDeviceId",
        "setGlobalUserProperties",
        "identify",
        "clearUserProperties",
        "setGroup",
        "logRevenueV2",
        "regenerateDeviceId",
        "groupIdentify",
        "onInit",
        "logEventWithTimestamp",
        "logEventWithGroups",
        "setSessionId",
        "resetSessionId",
      ]

      /**
       * @param e
       */
      function v(e) {
        /**
         * @param t
         */
        function t(t) {
          e[t] = function () {
            e._q.push([t].concat(Array.prototype.slice.call(arguments, 0)))
          }
        }
        for (var n = 0; n < d.length; n++) {
          t(d[n])
        }
      }
      v(n)
      n.getInstance = function (e) {
        e = (!e || e.length === 0 ? "$default_instance" : e).toLowerCase()
        if (!n._iq) n._iq = {}
        if (!n._iq.hasOwnProperty(e)) {
          n._iq[e] = {
            _q: [],
          }
          v(n._iq[e])
        }
        return n._iq[e]
      }
      e.amplitude = n
      amplitude.getInstance().init(vm.amplitudeApiKey)
      vm.identifyUser()
    })(window, document)
    this.amplitudeUnsubHandler = this.$store.subscribe((mutation) => {
      if (["user/SET", "user/agency/SET", "user/band/SET"].includes(mutation.type))
        this.identifyUser()
    })
  },
  beforeDestroy() {
    if (typeof this.amplitudeUnsubHandler === "function")
      this.amplitudeUnsubHandler()
  },
  computed: {
    amplitudeApiKey() {
      return Vue.config.devtools
        ? "585425c66d80ced6591f673cf031a2c2"
        : "ffcffafb021d8e1f4555d5580925396b"
    },
    ...mapState({
      user: (state) => state.user,
    }),
  },
  methods: {
    identifyUser() {
      if (
        this.$store.getters["user/IS_LOGGED_IN"] &&
        typeof amplitude === "object" &&
        amplitude !== null
      ) {
        amplitude.getInstance().setUserId(this.$store.state.user.id)
        const id = new amplitude.Identify()
        id.set("email", this.user.email)
        id.set("balance", this.user.grooviz)
        id.set("is_active", this.user.is_active)
        id.set("is_agency", this.$store.getters["user/IS_AGENCY"])
        id.set("is_facebook", this.user.is_facebook)
        id.set("is_verified_mail", this.user.is_verified_mail)
        id.set("kind", this.$store.getters["user/KIND"])
        id.set("lang", this.user.lang)
        id.set("first_name", this.user.first_name)
        id.set("last_name", this.user.last_name)
        id.set("percent_1", this.$store.state.user.id % 100 < 1)
        id.set("percent_2", this.$store.state.user.id % 100 < 2)
        id.set("percent_5", this.$store.state.user.id % 100 < 5)
        id.set("percent_10", this.$store.state.user.id % 100 < 10)
        id.set("percent_25", this.$store.state.user.id % 100 < 25)
        id.set("percent_50", this.$store.state.user.id % 100 < 50)
        id.set("percent_75", this.$store.state.user.id % 100 < 75)
        id.set("percent_100", this.$store.state.user.id % 100 <= 100)
        amplitude.getInstance().identify(id)
      }
    },
  },
}
